import React, { useState } from 'react';
import { motion } from "framer-motion";
import { fadeIn } from '../variants';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import axios from "axios";
import { Toaster, toast } from 'react-hot-toast';
import APIEndPoints from '../middleware/APIEndPoints';


const Contact = () => {


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(APIEndPoints.contactUS.url, formData);

      // Access the success message from the response
      const successMessage = response.data.message;
      if (successMessage) {
        toast.success(successMessage);
      };


      setFormData({
        name: '',
        email: '',
        message: ''
      });
      
    } catch (err) {
      // Check if there are validation errors returned from the backend
      if (err.response && err.response.data.errors) {
        const errorMessages = err.response.data.errors.map(error => error.msg); // Extract the error messages
        errorMessages.forEach(message => toast.error(message)); // Show each error message using toast
      } else {
        const errorMessage = err.response?.data?.message || 'Something went wrong!';
        toast.error(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className='section' id='contact'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row '>

          {/* text */}
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 flex justify-start items-center'>
            <div>
              <h4 className='text-xl uppercase text-accent font-medium mb-2 tracking-wide'>Get in touch</h4>
              <h2 className='text-[45px] lg:text-[90px] leading-none mb-12'>Let's work <br /> together!</h2>

              {/* Contact Information */}
              <div className='flex flex-col space-y-4'>
                <div className='flex items-center space-x-3'>
                  <FiPhone className='text-accent text-2xl' />
                  <span className='text-lg'>+977 9840041397</span>
                </div>
                <div className='flex items-center space-x-3'>
                  <FiMail className='text-accent text-2xl' />
                  <span className='text-lg'>basyalabhijan@gmail.com</span>
                </div>
                <div className='flex items-center space-x-3'>
                  <FiMapPin className='text-accent text-2xl' />
                  <span className='text-lg'>Baneshwor, Kathmandu, Nepal</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* form */}
          <motion.form
            variants={fadeIn('left', 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            onSubmit={handleSubmit}
            className='flex-1 border rounded-2xl flex flex-col gap-y-6 pb-24 p-6 items-start mt-10 sm:mt-0'>

            {/* Input Wrapper for Name */}
            <div className="relative w-full">
              <input
                name='name'
                value={formData.name}
                onChange={handleChange}
                className='bg-transparent border-b py-3 outline-none w-full placeholder:text-transparent focus:border-accent transition-all peer'
                type='text'
                placeholder="Your name"
                required />

              <label className="absolute left-0 top-3 text-blue-gray-400 transition-all duration-300 
              peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-blue-gray-400 
              peer-focus:top-[-0.75rem] peer-focus:text-sm peer-focus:text-pink-500 peer-focus:font-bold
              peer-valid:top-[-0.75rem] peer-valid:text-sm peer-valid:text-pink-500 peer-valid:font-bold">
                Your name
              </label>
            </div>

            {/* Input Wrapper for Email */}
            <div className="relative w-full">
              <input
                name='email'
                value={formData.email}
                onChange={handleChange}
                className='bg-transparent border-b py-3 outline-none w-full placeholder:text-transparent focus:border-accent transition-all peer'
                type='text'
                placeholder="Enter your email"
                required />

              <label className="absolute left-0 top-3 text-blue-gray-400 transition-all duration-300 
              peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-blue-gray-400 
              peer-focus:top-[-0.75rem] peer-focus:text-sm peer-focus:text-pink-500 peer-focus:font-bold
              peer-valid:top-[-0.75rem] peer-valid:text-sm peer-valid:text-pink-500 peer-valid:font-bold">
                Enter your email
              </label>
            </div>
            {/* Input Wrapper for Message */}
            <div className="relative w-full">
              <textarea
                name='message'
                value={formData.message}
                onChange={handleChange}
                className='bg-transparent border-b py-3 outline-none w-full placeholder:text-transparent focus:border-accent transition-all peer resize-none'
                placeholder="Your message"
                required />

              <label className="absolute left-0 top-3 text-blue-gray-400 transition-all duration-300 
              peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-blue-gray-400 
              peer-focus:top-[-0.75rem] peer-focus:text-sm peer-focus:text-pink-500 peer-focus:font-bold
              peer-valid:top-[-0.75rem] peer-valid:text-sm peer-valid:text-pink-500 peer-valid:font-bold">
                Your message
              </label>
            </div>

            <button type='submit' className='btn btn-lg' disabled={loading}>
              {loading ? 'Sending...' : 'Send message'}
            </button>
          </motion.form>
        </div>
        <Toaster />
      </div>
    </section>
  );
};

export default Contact;
